import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogActions,
    DialogContent,
    Button,
    Fade,
    Typography,
} from '@mui/material';

const MUIAlertModal = ({
    open,
    onClose,
    onConfirm,
    title,
    message,
    confirmLabel = 'Yes',
    cancelLabel = 'No',
    confirmButtonProps = {},
    cancelButtonProps = {},
    zIndex = 1500,
}) => {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            TransitionComponent={Fade}
            transitionDuration={300}
            fullWidth
            maxWidth="xs"
            sx={{ zIndex }}
            PaperProps={{
                component: 'form',
                onSubmit: (e) => {
                    e.preventDefault();
                    if (onConfirm) onConfirm(e);
                },
                sx: {
                    boxShadow: 6,
                    borderRadius: 2,
                    backgroundColor: '#FFFFFF',
                },
            }}
        >
            <DialogTitle>
                <h3
                    style={{
                        fontFamily: '"Gotham XNarrow SSm A", "Gotham XNarrow SSm B"',
                        fontSize: '2rem',
                        fontWeight: 600,
                        margin: 0,
                    }}
                >
                    {title}
                </h3>
            </DialogTitle>
            {message && (
                <DialogContent sx={{ paddingTop: 0 }}>
                    {typeof message === 'string' ? (
                        <Typography variant="body1">{message}</Typography>
                    ) : (
                        message
                    )}
                </DialogContent>
            )}
            <DialogActions sx={{ justifyContent: 'center', paddingBottom: '2rem' }}>
                <Button
                    variant="standard"
                    color="error"
                    type="button"
                    onClick={onClose}
                    {...cancelButtonProps}
                >
                    {cancelLabel}
                </Button>
                <Button
                    variant="standard"
                    color="update"
                    type="submit"
                    {...confirmButtonProps}
                >
                    {confirmLabel}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default MUIAlertModal;
